import { render, staticRenderFns } from "./shuLiangBiLi.vue?vue&type=template&id=14402f8e&scoped=true"
import script from "./shuLiangBiLi.vue?vue&type=script&lang=js"
export * from "./shuLiangBiLi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14402f8e",
  null
  
)

export default component.exports